import { useState } from 'react';
import Figura from './Figura';
import Visor from './Visor';
import useCarrusel from '../hooks/useCarrusel';
import { galeria } from '../data/fotos';

const Flecha = ({ hacia }) => (
  <svg width="17" height="11" viewBox="0 0 17 11" fill="none" aria-hidden="true">
    <g
      stroke="currentColor"
      strokeWidth="1"
      transform={hacia === 'izq' ? 'translate(17 0) scale(-1 1)' : undefined}
    >
      <path d="M0 5.5h15.5" />
      <path d="M11.4 1.2 15.7 5.5l-4.3 4.3" />
    </g>
  </svg>
);

export default function Galeria() {
  const { tira, barra, alInicio, alFinal, desplazar, huboArrastre } = useCarrusel();
  const [mirando, setMirando] = useState(null);

  return (
    <section className="galeria" id="galeria">
      <div className="envoltura">
        <div className="galeria__cabeza cabecera" data-reveal="">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
            <p className="rotulo">Galería</p>
            <h2 className="titulo">Trabajos recientes</h2>
          </div>
          <div className="mandos">
            <button
              type="button"
              className="mando"
              onClick={() => desplazar(-1)}
              disabled={alInicio}
              aria-label="Ver fotos anteriores"
            >
              <Flecha hacia="izq" />
            </button>
            <button
              type="button"
              className="mando"
              onClick={() => desplazar(1)}
              disabled={alFinal}
              aria-label="Ver fotos siguientes"
            >
              <Flecha hacia="der" />
            </button>
          </div>
        </div>
      </div>

      <div
        className="tira"
        ref={tira}
        tabIndex={0}
        role="region"
        aria-label="Galería de fotografías, desplazable de lado"
      >
        {galeria.map((foto, i) => (
          <button
            type="button"
            className="tira__item"
            key={`${foto.src}-${i}`}
            data-orientacion={foto.orientacion}
            onClick={() => {
              if (huboArrastre.current) return;
              setMirando(i);
            }}
            aria-label={`Ver en grande: ${foto.alt}`}
          >
            <Figura foto={foto} retraso={Math.min(i, 4) * 90} />
          </button>
        ))}
        <div className="tira__fin" aria-hidden="true" />
      </div>

      <div className="envoltura">
        <div className="tira__barra" ref={barra} aria-hidden="true">
          <span />
        </div>
      </div>

      <Visor
        fotos={galeria}
        indice={mirando}
        onCerrar={() => setMirando(null)}
        onIr={(paso) => setMirando((i) => i + paso)}
      />
    </section>
  );
}
